import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { isNotNullOrUndefined } from '@vy/utils';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useFormattedXeroProducts } from '../../../../../../../hooks/use-formatted-xero-products';

type XeroProductsDropdownGenericProps<FormType extends FieldValues> = {
  fieldPath: FieldPath<FormType>;
  control: Control<FormType>;
  showDropdown: boolean;
};

export function XeroProductsDropdownGeneric<FormType extends FieldValues>({
  fieldPath,
  control,
  showDropdown,
}: XeroProductsDropdownGenericProps<FormType>) {
  const { products: formattedProducts, isLoading, setSearchInput } = useFormattedXeroProducts();

  return (
    <Controller
      control={control}
      name={fieldPath}
      render={({ field }) => {
        const matchingProduct = isNotNullOrUndefined(field.value)
          ? formattedProducts.find((product) => product.id === field.value) ?? null
          : null;

        return (
          <Autocomplete
            disabled={!showDropdown || isLoading}
            options={formattedProducts}
            loading={isLoading}
            multiple={false}
            getOptionLabel={(option) => option.name}
            getOptionKey={(option) => option.id}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={matchingProduct}
            onChange={(_, value) => {
              field.onChange(value?.id ?? null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Xero ERP ID"
                placeholder="Select Xero Product"
                size="medium"
                slotProps={{
                  ...params.slotProps,
                  inputLabel: { shrink: true },

                  input: {
                    ...params.slotProps.input,
                    endAdornment: (
                      <>
                        {isLoading ? <CircularProgress color="inherit" size={16} /> : null}
                        {params.slotProps.input.endAdornment}
                      </>
                    ),
                  }
                }}
                onChange={(e) => {
                  setSearchInput(e.target.value || undefined);
                }}
              />
            )}
          />
        );
      }}
    />
  );
}
